import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

import { GenreWithCurators } from '../spotifyCampaignGenresApi'

export interface SpotifyArtistGenre {
  id: number
  genreName: string
}

export interface SpotifyArtist {
  genres?: SpotifyArtistGenre[]
  name: string
  photoUrl?: string
  spotifyId?: string
}

export interface SpotifyArtistWithCuratorsCount {
  genres: GenreWithCurators[]
  name: string
  photoUrl: string
  spotifyId: string
}

const spotifyArtistsApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getSimilarArtists: build.query<SpotifyArtist[], string>({
      query: (campaignId) => ({
        url: `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/${campaignId}/similar-artists`,
        method: 'GET',
      }),
    }),
    getSpotifyArtists: build.query<SpotifyArtist[], string>({
      query: (search) => ({
        url: `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/spotify-artists/?search=${search}`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useLazyGetSpotifyArtistsQuery, useGetSimilarArtistsQuery } =
  spotifyArtistsApi
